import React, {useEffect} from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
    onProductFormAttributeChange,
    onProductFormChange,
    selProductAttributes,
    selProductForm
} from "../../../stores/product/slice";
import Checkbox from "@mui/material/Checkbox";
import {Chip} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import DatePicker from "react-datepicker2";
import Dropzone from "react-dropzone";
import {useDispatch, useSelector} from "react-redux";
import useValidation from "../../../validation/useValidation";
import {productValidations} from "../../../stores/product/model";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import axios from "axios";
import {strings} from "../../../strings";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {DefField} from "../../module";

const R = require('ramda');


const icon = <CheckBoxOutlineBlankIcon/>;
const checkedIcon = <CheckBoxIcon/>;

export default function BasicInformation(props) {

    const [allCategory, setAllCategory] = React.useState([]);
    const [allTags, setAllTags] = React.useState([]);
    const product = useSelector(selProductForm);
    const attributesValue = useSelector(selProductAttributes);
    const dispatch = useDispatch();

    const {
        name,
        category,
        attributes,
        tags,
        is_active
    } = product;

    const {errors, checkFiled, checkValidation, slug} = props;

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onProductFormChange({name, value}))
    }

    function setParametersMainAttribute(event) {
        const {value, name} = event.target;
        dispatch(onProductFormAttributeChange({name, value}))
    }


    async function getAllCategory() {
        await axios.get(strings.baseUrl + `category`)
            .then(result => {
                if (result.data.status_code === 200) {
                    let allArray = [];
                    result.data.data.categories.map(item => {
                        const double = x => R.assoc('parentName', item.name, x);
                        allArray = [...allArray, R.map(double, item.children)]
                    })
                    setAllCategory(R.flatten(allArray))
                } else if (result.data.status_code === 401) {
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    async function getAllTags() {
        await axios.get(strings.baseUrl + `tag`)
            .then(result => {
                if (result.data.status_code === 200) {
                    setAllTags(result.data.data.tags)
                } else if (result.data.status_code === 401) {
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        getAllCategory();
        getAllTags()
    }, [])

    const allStatus = [
        {
            title: 'غیر فعال',
            value: 0
        },
        {
            title: 'فعال',
            value: 1
        },
        {
            title: 'غیر قابل خرید',
            value: 2
        },
    ]


    return (
        <Grid container spacing={2}
              className="d-flex flex-wrap divParentContentBasicInformation mt-2">
            <Grid
                item
                xs={12} sm={6} lg={4} xl={4}
                className="d-flex justify-content-center align-items-center"
            >
                <TextField
                    label="عنوان کتاب"
                    variant="outlined"
                    size=""
                    name={'name'}
                    value={name}
                    error={errors?.name?.length > 0}
                    className={`w-100 descriptionInput`}
                    onChange={(e) => setParametersMain(e)}
                />
            </Grid>
            <Grid
                item
                xs={12} sm={6} lg={4} xl={4}
                className="d-flex justify-content-center align-items-center parentMultiselectProductType"
            >
                <Autocomplete
                    limitTags={1}
                    multiple
                    disableCloseOnSelect
                    className="w-100"
                    value={allCategory.filter(x => category.some(({id}) => x.id === id))}
                    getOptionLabel={(option) => option?.name}
                    groupBy={(option) => option.parentName}
                    onChange={(event, newValue) => {
                        checkFiled('category', newValue);
                        dispatch(onProductFormChange({name: 'category', value: newValue}))
                    }}
                    options={allCategory}
                    // renderOption={(props, option, {selected}) => {
                    //     return <li {...props}>
                    //         <Checkbox
                    //             icon={icon}
                    //             checkedIcon={checkedIcon}
                    //             style={{marginRight: 8}}
                    //             // checked={category.find(x => x.id === option.id)}
                    //             checked={selected}
                    //         />
                    //         {option.name}
                    //     </li>
                    // }}
                    renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                            <Chip
                                label={option.name}
                                {...getTagProps({index})}
                            />
                        ))
                    }
                    renderInput={(params) =>
                        <>
                            <TextField {...params}
                                       error={errors?.category?.length > 0}
                                       label={'دسته بندی'}
                                       variant="outlined"
                                       type="text"
                                       placeholder="انتخاب دسته بندی"
                            />
                        </>
                    }
                />
            </Grid>
            <Grid item
                  xs={12} sm={6} lg={4}
                  className="d-flex
                                              justify-content-center
                                              align-items-center
                                              parentMultiselectProductType"
            >
                <Autocomplete
                    limitTags={1}
                    multiple
                    id="checkboxes-tags-demo"
                    className="w-100"
                    size=""
                    value={allTags.filter(x => tags.some(({id}) => x.id === id))}
                    options={allTags}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.name}
                    onChange={(event, value) => {
                        checkFiled('tags', value);
                        dispatch(onProductFormChange({name: 'tags', value: value}))
                    }}
                    renderInput={(params) => (
                        <TextField {...params}
                                   error={errors?.tags?.length > 0}
                                   variant="outlined"
                                   label="برچسب های محصول"
                                   placeholder="انتخاب برچسب"/>
                    )}
                />
            </Grid>
            <Grid item
                  xs={12} sm={6} lg={4}
                  className="d-flex
                                              justify-content-center
                                              align-items-center
                                              parentMultiselectProductType"
            >
                <Autocomplete
                    id="checkboxes-tags-demo"
                    className="w-100"
                    size=""
                    value={is_active !== "" ? allStatus.find(x => x.value === is_active) : allStatus[1]}
                    options={allStatus}
                    getOptionLabel={(option) => option.title}
                    onChange={(event, value) => {
                        dispatch(onProductFormChange({name: 'is_active', value: value.value}))
                    }}
                    renderInput={(params) => (
                        <TextField {...params}
                                   variant="outlined"
                                   label="وضعیت محصول"
                                   placeholder="انتخاب وضعیت"/>
                    )}
                />
            </Grid>
            {attributes.map((data, i) => {
                const dropValue = data.type.options.find(x => x.id === attributesValue[data.name]?.id)
                return data.type.name === "text" ?
                    <Grid item xs={12} sm={6} lg={4}>
                        <TextField
                            label={data.label}
                            name={data.name}
                            key={i}
                            value={attributesValue[data.name]}
                            onChange={setParametersMainAttribute}
                        />
                    </Grid>
                    :
                    <Grid item xs={12} sm={6} lg={4}>
                        {slug ?
                            dropValue &&
                            <Autocomplete
                                key={i}
                                className="w-100"
                                value={dropValue}
                                // value={attributesValue[data.name]}
                                openOnFocus={true}
                                getOptionLabel={(option) => option.value ? option.value : "null"}
                                onInputChange={(event, value) => {
                                    let res = data.type.options.filter(x => x.value === value);
                                    if (res.length === 1) {
                                        dispatch(onProductFormAttributeChange({name: [data.name], value: res[0]}))
                                    }
                                }}
                                options={data.type.options}
                                style={{width: "100%"}}
                                renderInput={(params) =>
                                    <TextField {...params}
                                               label={data.label}
                                               variant="outlined"
                                    />
                                }
                            />
                            :
                            <Autocomplete
                                key={i}
                                className="w-100"
                                value={dropValue}
                                // value={attributesValue[data.name]}
                                openOnFocus={true}
                                getOptionLabel={(option) => option.value ? option.value : "null"}
                                onInputChange={(event, value) => {
                                    let res = data.type.options.filter(x => x.value === value);
                                    if (res.length === 1) {
                                        dispatch(onProductFormAttributeChange({name: [data.name], value: res[0]}))
                                    }
                                }}
                                options={data.type.options}
                                style={{width: "100%"}}
                                renderInput={(params) =>
                                    <TextField {...params}
                                               label={data.label}
                                               variant="outlined"
                                    />
                                }
                            />
                        }
                    </Grid>

            })}
        </Grid>
    );
}
